export default __webpack_public_path__ + "static/media/massup_background_s2.09a235fc.jpg";